import { jsx, jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { forwardRef, useMemo } from "react";
import "../../../../Button/Button.js";
import "../../../../InputControl/InputControl.js";
import { InputBase, MUI_INPUT_BASE_CLASSNAME } from "../../../../InputControl/Input/InputBase.js";
import "../../../../PhoneInputControl/PhoneInputControl.js";
import "../../../../PhoneInputControl/PhoneInput/PhoneInput.js";
import "../../../../IconButton/IconButton.js";
import "../../../../common/ControlBody.js";
import "../../context/SelectContext.js";
import "../../../../Dialog/Dialog.js";
import { IconButton } from "../../../../IconButtonNew/IconButton.js";
import "../../../../../icons/24/Action/Close.js";
import "../../../../../icons/24/Arrow/ChevronLeft.js";
import { inheritDataTestId } from "../../../../../utils/dataTestId.js";
import { DATA_TEST_ID_INHERITED } from "../../../../../constants/DATA_TEST_ID_INHERITED.js";
import "../../MultiSelect/context/MultiSelectContext.js";
import "../../../../../icons/24/System/Check.js";
import { ChevronDownIcon } from "../../../../../icons/24/Arrow/ChevronDown.js";
import { spreadSx } from "../../../../../utils/spreadSx.js";
import "../../../../TextareaControl/TextareaControl.js";
import "../../../../SearchControl/SearchControl.js";
import "../../../../../icons/24/System/Search.js";
import "../../../../FormattedPhone/FormattedPhoneNumber.js";
import "../../../../Avatar/styles.js";
import "../../../../CheckboxGroup/Checkbox/styles.js";
import "../../../../CheckboxGroup/styles.js";
import "../../../../RadioGroup/Radio/styles.js";
import "../../../../RadioGroup/styles.js";
import "../../../../RatingButton/styles.js";
import "../../../../FloatingActionButton/styles.js";
import "../../../../SortingButton/styles.js";
import "../../../../SquareButton/styles.js";
import "../../../../Toggle/styles.js";
import "../../../../Dialog/StyledDialog.js";
import "../../../../Chips/Chip/styles.js";
import "../../../../ResultMarksNumber/styles.js";
import "../../../../Progress/ProgressCircle/styles.js";
import "../../../../Loaders/LoaderCircle/styles.js";
import "../../../../Loaders/LoaderLine/styles.js";
import "../../../../SegmentedControl/styles.js";
import "../../../../ResultMarksText/styles.js";
import "../../../../Link/styles.js";
import "../../../../Tag/Tag.js";
import "../../../../DatePicker/constants.js";
import "../../../../DatePicker/components/RangePicker/context/DateRangePickerContext.js";
import "../../../../DatePicker/components/RangePicker/context/DateRangePickerContextActions.js";
import "../../../../DatePicker/shared/fragments/CalendarCell/CalendarCell.js";
import "../../../../../external/classnames/index.js";
import "../../../../Scrollbar/Scrollbar.js";
import "../../../../DatePicker/shared/fragments/MonthYearSelector/YearSelector.js";
import "../../../../DatePicker/components/DatePicker/context/DatePickerContext.js";
import "../../../../DatePicker/components/DatePicker/context/DatePickerContextActions.js";
import "../../../../MobileBottomSheet/MobileBottomSheet.js";
import "../../../../List/ListItem/ListItem.js";
import "../../../../Nowrap.js";
import "../../../../List/ListItemTree/TreeListItem.js";
import "../../../../List/ListItemTree/components/Label.js";
const SelectInput = forwardRef(
  ({ open, size = "md", value, sx, mobileView, showCount = !0, ...props }, ref) => {
    const valueString = useMemo(() => (value == null ? void 0 : value[0]) ?? "", [value]), count = showCount && value && value.length > 1 ? value.length - 1 : void 0;
    return /* @__PURE__ */ jsx(
      InputBase,
      {
        "data-test-id": DATA_TEST_ID_INHERITED,
        size,
        value: valueString,
        focus: open,
        autoComplete: !1,
        ref,
        sx: [styles.input, ...spreadSx(sx)],
        ...props,
        endAdornment: /* @__PURE__ */ jsx(Stack, { sx: [styles.chevron, sizeStyles.chevron[size]], children: /* @__PURE__ */ jsx(
          IconButton,
          {
            size: chevronSizeMap[size],
            color: "tertiary",
            "data-test-id": inheritDataTestId(props, "chevron-btn"),
            children: /* @__PURE__ */ jsx(
              ChevronDownIcon,
              {
                style: {
                  rotate: mobileView ? "-90deg" : open ? "180deg" : "0deg"
                }
              }
            )
          }
        ) }),
        slots: {
          input: (props2) => /* @__PURE__ */ jsx(
            FakeInput,
            {
              "data-test-id": DATA_TEST_ID_INHERITED,
              count,
              size,
              ...props2
            }
          )
        }
      }
    );
  }
);
SelectInput.displayName = "SelectInput";
const FakeInput = ({ value, count, size, placeholder }) => /* @__PURE__ */ jsxs(Stack, { className: MUI_INPUT_BASE_CLASSNAME, sx: styles.fakeInputContainer, children: [
  value ? /* @__PURE__ */ jsx(Typography, { sx: styles.ellipsis, children: value }) : /* @__PURE__ */ jsx(Typography, { sx: [styles.ellipsis, styles.placeholder], children: placeholder }),
  count ? /* @__PURE__ */ jsxs(Typography, { sx: [styles.counter, sizeStyles.counter[size]], children: [
    "+",
    count
  ] }) : null
] }), chevronSizeMap = {
  sm: "xs",
  md: "lg",
  lg: "lg"
}, sizeStyles = {
  chevron: {
    sm: {
      paddingRight: 6
    },
    md: {
      paddingRight: 6
    },
    lg: {
      paddingRight: 6
    }
  },
  counter: {
    sm: {
      lineHeight: "24px"
    },
    md: {
      lineHeight: "24px"
    },
    lg: {
      lineHeight: "30px"
    }
  }
}, styles = {
  chevron: {
    right: 0,
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: 0
  },
  input: {
    input: {
      paddingRight: 0
    }
  },
  counter: {
    typography: "14_18_500",
    backgroundColor: (t) => t.palette.tag.secondary.bg.default,
    paddingLeft: 6,
    paddingRight: 6,
    lineHeight: "24px"
  },
  fakeInputContainer: {
    height: "100%",
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
    paddingRight: "0!important",
    gap: 6
  },
  ellipsis: {
    minWidth: 0,
    fontSize: "inherit",
    fontWeight: "inherit",
    fontFamily: "inherit",
    lineHeight: "inherit",
    flex: "0 1 auto",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  placeholder: {
    color: (t) => t.palette.field.placeholder
  }
};
export {
  SelectInput
};
//# sourceMappingURL=SelectInput.js.map
